//
//
//
//
//
//

export default {
  name: 'DistributionTextSetting'
};